interface SectionTitleProps {
  title: string;
  subtitle?: string;
  href?: string;
}

export default function SectionTitle({ title, subtitle, href }: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between mb-6">
      <div>
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
          {title}
        </h2>
        {subtitle && (
          <p className="text-sm text-foreground-400 mt-1">{subtitle}</p>
        )}
      </div>
      {href && (
        <a
          href={href}
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line text-xs" />
        </a>
      )}
    </div>
  );
}